import React from 'react';
import PropTypes from 'prop-types';
import DefaultPropTypes from '../../utils/prop-types';
import MimeType from '../../utils/mime-type';
import VideoGalleryItemDetailView from "./video-gallery-item-detail-view.jsx";

const VideoGalleryItemView = (props) => {
  const fileTypes = {
    default: 'e866',
    pdf: 'e86a',
    img: 'e89c',
    video: 'e8a0',
    embed: 'e8a0',
    external: 'ea41',
  };

  const getFileTypeIcon = (mimeType) => {
    let fileType = fileTypes.default;
    if (mimeType === MimeType.PDF) fileType = fileTypes.pdf;
    else if (mimeType === MimeType.MP4) fileType = fileTypes.video;
    else if (mimeType === MimeType.JPEG || mimeType === MimeType.PNG || mimeType === MimeType.BMP) fileType = fileTypes.img;
    else if (mimeType === MimeType.EMBED) fileType = fileTypes.embed;
    else if (mimeType === MimeType.EXTERNAL) fileType = fileTypes.external;

    return fileType;
  };

  const getFileType = mimeType => mimeType.split('/').slice(1);

  const { item } = props;

  const detailViewOn = props.selectedItem !== null && props.item.id === props.selectedItem.id;

  const showImage = (!detailViewOn && !props.isDesktop) || props.isDesktop;

  return (
    <div className={`file-container`}>
      {
        showImage &&
        <div className={`video-container`}>
          <a
            className={`file-link ${item.shouldDownload() && ' file-download-directly'} ${item.locked && 'file-locked'}`}
            id={item.id}
            rel="noopener noreferrer"
            target="_blank"
            href={item.mimeType === MimeType.EMBED ? '' : item.url}
            aria-expanded={detailViewOn}
            aria-controls={`detail-${item.id}`}
            onClick={(e) => {
              props.onItemClick.apply(null, [e, item]);
            }}
          >
            <img src={item.image} alt=""/>
            <div className={`video-play-button`}/>
          </a>
        </div>
      }
      {
        detailViewOn &&
        <VideoGalleryItemDetailView
          {...props}
          settings={props.settings}
          dictionary={props.dictionary}
          isDesktop={props.isDesktop}
          selectedItem={props.selectedItem}
          onClose={props.onClose}
        />
      }
      <div className={`file-description`}>
        <p className={`file-title`}>{item.name}</p>
      </div>
    </div>
  );
};

VideoGalleryItemView.propTypes = {
  onItemClick: PropTypes.func.isRequired,
  item: DefaultPropTypes.item.isRequired,
};

export default VideoGalleryItemView;
